import React from 'react';
import {Map} from 'immutable';
import SnippetSelectionQuestionEditor from './SnippetSelectionEditor.react';
import {SnippetSelectionQuestion} from './SnippetSelectionQuestion.react';
import SnippetSelectionExplanation from './SnippetSelectionExplanation.react';

/**
 * @todo: Make a generic response stats component that returns
 * percentage correct / percentage incorrect and use that here
 */
class SnippetSelectionResponseStats extends React.Component {
  render() {
    return null;
  }
}

const SnippetSelectionQuestionType = new Map({
  type: 'snippet-selection',
  label: 'Snippet Selection',
  questionRenderer: SnippetSelectionQuestion,
  explanationRenderer: SnippetSelectionExplanation,
  responseStatsRenderer: SnippetSelectionResponseStats,
  editor: SnippetSelectionQuestionEditor,
  isHidden: false
});

export default SnippetSelectionQuestionType;
